// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoggedInNav_container__rnxZc{
    top: 0;
    width: calc(100% - 70px);
    padding-left: 35px;
    padding-right: 35px;
    background-color: #FFFFFF;
    border: 1px solid #70A9A11A;
    border-radius: 0 0 30px 30px;
    box-shadow: 0 3px 12px 0 #40798C12;
}
.LoggedInNav_nav__ugtpx{
    display: flex;
    align-items: center;
    height: 93px;
}
@media(max-width: 600px){
    .LoggedInNav_container__rnxZc{
        width: calc(100% - 40px);
        padding-left: 20px;
        padding-right: 20px;
    }
    .LoggedInNav_nav__ugtpx{
        height: 73px;
    }
}
.LoggedInNav_title__u-xQP{
    color: #274C77;
    font-family: 'Gotham Bold', serif;
    font-size: 24px;
    text-decoration: none;
}
.LoggedInNav_title__u-xQP img{
    position: relative;
    top: 3px;
    height: 30px;
    width: 150px;
}
.LoggedInNav_menu__uOpnP, .LoggedInNav_close__-dwP1{
    display: none;
    cursor: pointer;
}
.LoggedInNav_menu__uOpnP{
    height: 12px;
    width: 18px;
}
.LoggedInNav_close__-dwP1{
    height: 14px;
    width: 14px;
}
.LoggedInNav_links__2Llnc{
    margin-left: 60px;
}
@media(max-width: 1020px){
    .LoggedInNav_links__2Llnc{
        margin-left: 35px;
    }
}
@media(max-width: 900px){
    .LoggedInNav_title__u-xQP{
        display: none;
    }
    .LoggedInNav_menu__uOpnP, .LoggedInNav_close__-dwP1{
        display: inline-block;
    }
    .LoggedInNav_links__2Llnc{
        display: none;
    }
}
.LoggedInNav_link__uRM0H{
    margin-right: 50px;
    color: #1F363D;
    text-decoration: none;
    font-family: 'Gotham Medium', serif;
    font-size: 16px;
}
@media(max-width: 1020px){
    .LoggedInNav_link__uRM0H{
        margin-right: 30px;
    }
}
.LoggedInNav_link__uRM0H.LoggedInNav_active__nAnOj{
    padding-bottom: 32.5px;
    border-bottom: 5px solid #274C77;
}
.LoggedInNav_profileContainer__z9joq{
    display: flex;
    position: relative;
    margin-left: auto;
}
.LoggedInNav_notificationsToggle__GUR-b{
    display: flex;
    align-items: center;
    position: relative;
    margin-right: 25px;
    cursor: pointer;
}
.LoggedInNav_bell__jJO3U{
    height: 24px;
    width: 24px;
}
.LoggedInNav_unseenNotificationsCount__jSUah{
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 8px;
    right: -5px;
    height: 17px;
    width: 17px;
    color: #FFFFFF;
    background: #F05252;
    font-size: 12px;
    border-radius: 50%;
}
.LoggedInNav_extendedCount__SE22N{
    height: 20px;
    width: 20px;
    font-size: 8px;
}
.LoggedInNav_profile__vG74K{
    display: flex;
    align-items: center;
    padding-left: 20px;
    border-left: 1px solid #1F363D1A;
    cursor: pointer;
}
.LoggedInNav_profilePicture__3dAEX{
    height: 51px;
    width: 51px;
    border-radius: 50%;
    object-fit: cover;
}
.LoggedInNav_profilePicturePlaceholder__hDJHz{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 51px;
    width: 51px;
    color: #578E86;
    background-color: #BFE1DC;
    font-size: 12px;
    font-family: 'Gotham Medium', serif;
    border-radius: 50%;
    letter-spacing: -1.5px;
}
.LoggedInNav_name__W0KLV{
    max-width: 180px;
    margin-left: 10px;
    color: #1F363D;
    font-size: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-x: hidden;
}
@media(max-width: 950px){
    .LoggedInNav_name__W0KLV{
        max-width: 140px;
    }
}
@media(max-width: 900px){
    .LoggedInNav_name__W0KLV{
        max-width: 180px;
    }
}
@media(max-width: 500px){
    .LoggedInNav_name__W0KLV{
        display: none;
    }
}
.LoggedInNav_downCaret__vHkp5{
    margin-left: 10px;
}
.LoggedInNav_subNav__sOpfr{
    position: absolute;
    top: 60px;
    left: 70px;
    width: calc(100% - 90px);
    min-width: 145px;
    padding: 5px 18px;
    background-color: #FFFFFF;
    border: 1px solid #1F363D1A;
    border-radius: 10px;
    box-shadow: 0 3px 12px 0 #00000012;
    z-index: 300;
}
@media(max-width: 500px){
    .LoggedInNav_subNav__sOpfr{
        left: auto;
        right: -20px;
        width: 145px;
    }
}
.LoggedInNav_subNavIcon__Zscq\\+{
    position: relative;
    top: 1px;
    height: 12px;
    width: 12px;
    margin-right: 12px;
}
.LoggedInNav_subNavLink__-u27t{
    display: block;
    width: 100%;
    padding: 15px 0;
    color: #1F363D;
    background-color: #FFFFFF;
    text-align: left;
    font-size: 14px;
    font-family: 'Gotham', serif;
    text-decoration: none;
    border: none;
    cursor: pointer;
}
.LoggedInNav_subNavLink__-u27t:not(:last-child){
    border-bottom: 1px solid #1F363D1A;
}
.LoggedInNav_mobileLinks__TiBWo{
    margin-bottom: 30px;
    border-top: 1px solid #1F363D1A;
}
.LoggedInNav_mobileLinks__TiBWo .LoggedInNav_link__uRM0H{
    display: block;
    margin-top: 20px;
    padding-top: 5px;
    padding-bottom: 5px;
}
.LoggedInNav_mobileLinks__TiBWo .LoggedInNav_link__uRM0H.LoggedInNav_active__nAnOj{
    padding-left: 15px;
    margin-left: -20px;
    border-left: 5px solid #274C77;
    border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/components/logged-in/LoggedInNav.module.css"],"names":[],"mappings":"AAAA;IACI,MAAM;IACN,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;IAC5B,kCAAkC;AACtC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI;QACI,wBAAwB;QACxB,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,YAAY;IAChB;AACJ;AACA;IACI,cAAc;IACd,iCAAiC;IACjC,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,YAAY;AAChB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,mCAAmC;IACnC,eAAe;AACnB;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,sBAAsB;IACtB,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;AACnB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,mCAAmC;IACnC,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;IAClC,YAAY;AAChB;AACA;IACI;QACI,UAAU;QACV,YAAY;QACZ,YAAY;IAChB;AACJ;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;IAC5B,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,kCAAkC;AACtC;AACA;IACI,mBAAmB;IACnB,+BAA+B;AACnC;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;AACvB","sourcesContent":[".container{\n    top: 0;\n    width: calc(100% - 70px);\n    padding-left: 35px;\n    padding-right: 35px;\n    background-color: #FFFFFF;\n    border: 1px solid #70A9A11A;\n    border-radius: 0 0 30px 30px;\n    box-shadow: 0 3px 12px 0 #40798C12;\n}\n.nav{\n    display: flex;\n    align-items: center;\n    height: 93px;\n}\n@media(max-width: 600px){\n    .container{\n        width: calc(100% - 40px);\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n    .nav{\n        height: 73px;\n    }\n}\n.title{\n    color: #274C77;\n    font-family: 'Gotham Bold', serif;\n    font-size: 24px;\n    text-decoration: none;\n}\n.title img{\n    position: relative;\n    top: 3px;\n    height: 30px;\n    width: 150px;\n}\n.menu, .close{\n    display: none;\n    cursor: pointer;\n}\n.menu{\n    height: 12px;\n    width: 18px;\n}\n.close{\n    height: 14px;\n    width: 14px;\n}\n.links{\n    margin-left: 60px;\n}\n@media(max-width: 1020px){\n    .links{\n        margin-left: 35px;\n    }\n}\n@media(max-width: 900px){\n    .title{\n        display: none;\n    }\n    .menu, .close{\n        display: inline-block;\n    }\n    .links{\n        display: none;\n    }\n}\n.link{\n    margin-right: 50px;\n    color: #1F363D;\n    text-decoration: none;\n    font-family: 'Gotham Medium', serif;\n    font-size: 16px;\n}\n@media(max-width: 1020px){\n    .link{\n        margin-right: 30px;\n    }\n}\n.link.active{\n    padding-bottom: 32.5px;\n    border-bottom: 5px solid #274C77;\n}\n.profileContainer{\n    display: flex;\n    position: relative;\n    margin-left: auto;\n}\n.notificationsToggle{\n    display: flex;\n    align-items: center;\n    position: relative;\n    margin-right: 25px;\n    cursor: pointer;\n}\n.bell{\n    height: 24px;\n    width: 24px;\n}\n.unseenNotificationsCount{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 8px;\n    right: -5px;\n    height: 17px;\n    width: 17px;\n    color: #FFFFFF;\n    background: #F05252;\n    font-size: 12px;\n    border-radius: 50%;\n}\n.extendedCount{\n    height: 20px;\n    width: 20px;\n    font-size: 8px;\n}\n.profile{\n    display: flex;\n    align-items: center;\n    padding-left: 20px;\n    border-left: 1px solid #1F363D1A;\n    cursor: pointer;\n}\n.profilePicture{\n    height: 51px;\n    width: 51px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n.profilePicturePlaceholder{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 51px;\n    width: 51px;\n    color: #578E86;\n    background-color: #BFE1DC;\n    font-size: 12px;\n    font-family: 'Gotham Medium', serif;\n    border-radius: 50%;\n    letter-spacing: -1.5px;\n}\n.name{\n    max-width: 180px;\n    margin-left: 10px;\n    color: #1F363D;\n    font-size: 16px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow-x: hidden;\n}\n@media(max-width: 950px){\n    .name{\n        max-width: 140px;\n    }\n}\n@media(max-width: 900px){\n    .name{\n        max-width: 180px;\n    }\n}\n@media(max-width: 500px){\n    .name{\n        display: none;\n    }\n}\n.downCaret{\n    margin-left: 10px;\n}\n.subNav{\n    position: absolute;\n    top: 60px;\n    left: 70px;\n    width: calc(100% - 90px);\n    min-width: 145px;\n    padding: 5px 18px;\n    background-color: #FFFFFF;\n    border: 1px solid #1F363D1A;\n    border-radius: 10px;\n    box-shadow: 0 3px 12px 0 #00000012;\n    z-index: 300;\n}\n@media(max-width: 500px){\n    .subNav{\n        left: auto;\n        right: -20px;\n        width: 145px;\n    }\n}\n.subNavIcon{\n    position: relative;\n    top: 1px;\n    height: 12px;\n    width: 12px;\n    margin-right: 12px;\n}\n.subNavLink{\n    display: block;\n    width: 100%;\n    padding: 15px 0;\n    color: #1F363D;\n    background-color: #FFFFFF;\n    text-align: left;\n    font-size: 14px;\n    font-family: 'Gotham', serif;\n    text-decoration: none;\n    border: none;\n    cursor: pointer;\n}\n.subNavLink:not(:last-child){\n    border-bottom: 1px solid #1F363D1A;\n}\n.mobileLinks{\n    margin-bottom: 30px;\n    border-top: 1px solid #1F363D1A;\n}\n.mobileLinks .link{\n    display: block;\n    margin-top: 20px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n}\n.mobileLinks .link.active{\n    padding-left: 15px;\n    margin-left: -20px;\n    border-left: 5px solid #274C77;\n    border-bottom: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LoggedInNav_container__rnxZc`,
	"nav": `LoggedInNav_nav__ugtpx`,
	"title": `LoggedInNav_title__u-xQP`,
	"menu": `LoggedInNav_menu__uOpnP`,
	"close": `LoggedInNav_close__-dwP1`,
	"links": `LoggedInNav_links__2Llnc`,
	"link": `LoggedInNav_link__uRM0H`,
	"active": `LoggedInNav_active__nAnOj`,
	"profileContainer": `LoggedInNav_profileContainer__z9joq`,
	"notificationsToggle": `LoggedInNav_notificationsToggle__GUR-b`,
	"bell": `LoggedInNav_bell__jJO3U`,
	"unseenNotificationsCount": `LoggedInNav_unseenNotificationsCount__jSUah`,
	"extendedCount": `LoggedInNav_extendedCount__SE22N`,
	"profile": `LoggedInNav_profile__vG74K`,
	"profilePicture": `LoggedInNav_profilePicture__3dAEX`,
	"profilePicturePlaceholder": `LoggedInNav_profilePicturePlaceholder__hDJHz`,
	"name": `LoggedInNav_name__W0KLV`,
	"downCaret": `LoggedInNav_downCaret__vHkp5`,
	"subNav": `LoggedInNav_subNav__sOpfr`,
	"subNavIcon": `LoggedInNav_subNavIcon__Zscq+`,
	"subNavLink": `LoggedInNav_subNavLink__-u27t`,
	"mobileLinks": `LoggedInNav_mobileLinks__TiBWo`
};
export default ___CSS_LOADER_EXPORT___;
